import { useMemo } from "react";

import Accordion from "@gx/dls/accordion/Accordion";
import Text, { TextSize, TextVariant } from "@gx/dls/text/Text";

import type { MockActivityItemType } from "@/pages/sources/components/edit/tabs/overview/types";

import { convertProtobufTimestampToDate, formatDateTime, getTimeAgo } from "@/utils/datetimes";

interface EditSourceOverviewActivityFeedItemProps {
  item: MockActivityItemType;
  isOpenInitial?: boolean;
}

const EditSourceOverviewActivityFeedItem = ({
  item,
  isOpenInitial = false,
}: EditSourceOverviewActivityFeedItemProps) => {
  const date = useMemo(() => {
    return convertProtobufTimestampToDate(item.createdAt);
  }, [item.createdAt]);

  const timestamp = useMemo(() => {
    return formatDateTime(date.toISOString());
  }, [date]);

  const timeAgo = useMemo(() => {
    return getTimeAgo(date);
  }, [date]);

  return (
    <Accordion
      icon={item.icon}
      header={item.title}
      subheader={timestamp}
      metric={
        <Text size={TextSize.BODY_SM} variant={TextVariant.SECONDARY}>
          {timeAgo}
        </Text>
      }
      isOpenInitial={isOpenInitial}
      borderRadius={6}
    >
      <Text size={TextSize.BODY_SM} variant={TextVariant.SECONDARY}>
        {item.detail}
      </Text>
    </Accordion>
  );
};

export default EditSourceOverviewActivityFeedItem;
